import { PublicationStatus } from 'lib-knowledge-management-common/graphql';
import { objectToSearchString } from 'use-query-params';

export function buildArticleEditorUrl({
  articleId,
}: {
  articleId: string;
}): string {
  const search = window.location.search;
  const searchString = objectToSearchString({
    articleParams: encodeURIComponent(
      search.startsWith('?') ? search.slice(1) : search,
    ),
  });

  return `/knowledge/article-editor/${articleId}?${searchString}`;
}

// Function that returns publication status label and color
export function getPublicationStatusLabelAndColor(
  publicationStatus: PublicationStatus,
): { label: string; color: string } {
  switch (publicationStatus) {
    case PublicationStatus.NeverPublished:
      return {
        label: 'Pre-release',
        color: 'var(--dixa-typography-color-tertiary)',
      };
    case PublicationStatus.Published:
      return {
        label: 'Published',
        color: 'var(--dixa-color-green-500)',
      };
    case PublicationStatus.Unpublished:
      return {
        label: 'Unpublished',
        color: 'var(--dixa-typography-color-tertiary)',
      };
    case PublicationStatus.PublishedWithDraft:
      return {
        label: 'Work in progress',
        color: 'var(--dixa-color-green-500)',
      };
  }
}
